module.exports = __webpack_public_path__ + "img/news_home_4.d58e774a.jpg";